import styled from "styled-components";

export const AlignmentSimple = styled.div`
  display: flex;
  flex-direction: ${props => (props.direction ? props.direction : "row")};
  justify-content: ${props =>
    props.horizontal ? props.horizontal : "space-between"};
  align-items: ${props => (props.vertical ? props.vertical : "flex-start")};
`;

export const Alignment = styled(AlignmentSimple)`
  width: ${props => (props.width ? props.width : "100%")};
  height: ${props => (props.height ? props.height : "100%")};
  position: ${props => (props.position ? props.position : "relative")};
`;

export const Padded = styled.div`
  padding-left: ${p =>
    p.horizontal ? p.horizontal : p.theme.paddingDefault}px;
  padding-right: ${p =>
    p.horizontal ? p.horizontal : p.theme.paddingDefault}px;
  padding-top: ${p => (p.vertical ? p.vertical : p.theme.paddingDefault)}px;
  padding-bottom: ${p => (p.vertical ? p.vertical : p.theme.paddingDefault)}px;
`;
